export default "__VITE_ASSET__CIBMNgmb__"